<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
import moment from 'moment';
export default {
  components: { ErrorMessage, Layout, PageHeader,ModelSelect },
  data() {
    return {
      title: "Flight Booking List",
      items: [
        {
          text: "Flight Booking",
          href: "/",
        },
        {
          text: "List",
          active: true,
        },
      ],
      admins: [],
        alladmins:[],
      pin: "",
      bookings: [],
        passengers:[],
        booking:"",
        status:"",
      user_id: "",
        tickets:[],
      booking_startdate: "",
      booking_enddate: "",
        travel_startdate: "",
        travel_enddate: "",
        airline_pnr:"",
        booking_status:"",
        ticket_no:"",
      remarks: "",
        user_type:"",
      errors: null,
        visible:false,
        display_div:true,
        message:"",
        search1:"",
        booking_statuses:[],
        search_fname:"",
        search_lname:"",
        search_uname:"",
        search_account_type:"",
        search_target_api:"",
        search_trip_type:"",
        search_api_pnr:"",
        search_airline_pnr:"",
        search_routes:"",
        search_booking_status:"",
        search_payment_status:"",
        search_total_passenger:"",
        search_ait:"",
        search_airline:"",
        search_gross_fare:"",
        search_base_fare:"",
        search_total_tax:"",
        search_invoice_fare:"",
        search_commission:"",
        search_markup:"",
        search_pnr:""
    };
  },
    created() {
       this.booking_status=this.$route.params.status;
       this.user_id=this.$route.params.user_id;
    },
    watch: {
        $route(to, from) {
            this.booking_status = this.$route.params.status;
        }
    },
  mounted() {

    this.getBookingStatuses();

      if(this.user_id != undefined){
          this.getUserID();
          this.display_div=false;
      }
      this.getAdminList();
      this.search();
  },
    computed: {
        filteredList() {
            return this.bookings.filter(booking => {
                return booking.search_reference_key.toLowerCase().includes(this.search1.toLowerCase())
                    && (booking.username==null ? '' : booking.username).toLowerCase().includes(this.search_uname.toLowerCase())
                    && (booking.airline_pnr==null ? '' : booking.airline_pnr).toLowerCase().includes(this.search_pnr.toLowerCase())
                    && (booking.api_pnr==null ? '' : booking.api_pnr).toLowerCase().includes(this.search_pnr.toLowerCase())

            })
        }
    },

    methods: {
      onClose(){
          this.visible=false;
      },
        searchFilterFunc2(val) {
            this.search1=val;
        },
        toggleDiv: function() {
            this.display_div = !this.display_div;
        },
        print(id) {
        window.open("#/booking/details/"+id);
        },
        async getUserID() {
            try {
                axios
                    .post("/api/get-user-id/" + this.user_id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.status) {
                           this.user_id=parseInt(response.data);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        sendMail(id) {

            try {
                axios
                    .post("/api/flight-booking-details-mail/" + id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("Mail Sent Successfully");

                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
    async getAdminList() {
      try {
        axios
          .get("/api/user/approved/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                let temp=response.data.data;
                let i;
                let arr=[];
                for (i=0;i<temp.length;i++){
                        if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                            if(temp[i].approved_agents[0].approval_status=='approved') {
                                temp[i].value = temp[i].id;
                                temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                arr.push(temp[i]);
                            }
                        }
                        if(temp[i].account_type=='b2c'){
                            if(temp[i].first_name==null){
                                temp[i].text=temp[i].email + '(unregistered)';
                            }else{
                                temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                            }
                            temp[i].value = temp[i].id;

                            arr.push(temp[i]);
                        }

                }
                this.alladmins=arr;
                this.admins = arr;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
        async getBookingStatuses() {
            try {
                axios
                    .get("/api/flight-booking/statuses", {
                        params: {
                            accessToken: localStorage.getItem("access_tocken"),
                        },
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.booking_statuses = response.data.data;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
    async search() {
      try {
        axios
          .get("/api/flight-booking/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              user_id: this.user_id,
              booking_startdate: this.booking_startdate,
                booking_enddate: this.booking_enddate,
                travel_startdate: this.travel_startdate,
                travel_enddate: this.travel_enddate,
                user_type:this.user_type,
                airline_pnr:this.airline_pnr,
                booking_status:this.booking_status,
                ticket_no:this.ticket_no,
            },
          })
          .then((response) => {
            if (response.data.status) {
                this.bookings=response.data.data;
              // var i;
              // for (i=0; i<res.length; i++){
              //     if((moment().isSame(res[i].created_at, 'day') || moment().isSame(res[i].updated_at, 'day'))) {
              //         res[i].void = true;
              //     }else {
              //         res[i].void = false;
              //     }
              //     // var j;
              //     // var all="";
              //     // for (j=0;j<res[i].flight_segments.length;j++){
              //     //    if(j<=0){
              //     //        all+=res[i].flight_segments[j].origin_code+'-'+res[i].flight_segments[j].destination_code;
              //     //    }
              //     //   else{
              //     //        if(res[i].flight_segments[j].origin_code==res[i].flight_segments[j-1].destination_code){
              //     //            all+='-'+res[i].flight_segments[j].destination_code;
              //     //        }
              //     //    }
              //     //
              //     // }
              //     // res[i].routes=all;
              // }
              // this.bookings = res;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      async voidTicketWarning(id) {
          var _this = this;
          try {
              this.$swal({
                  title: "Are you sure?",
                  text: "You can't revert your action",
                  type: "error",
                  showCancelButton: true,
                  confirmButtonText: "Yes, Void Ticket!",
                  cancelButtonText: "No",
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
              }).then((result) => {
                  if (result.value) {
                      _this.voidTicket(id);
                  } else {
                      this.$swal("Cancelled", "", "info");
                  }
              });
          } catch (err) {
              console.log(err);
          }
      },
      async cancelBookingMicroserviceWarning(id) {
          var _this = this;
          try {
              this.$swal({
                  title: "Are you sure?",
                  text: "You can't revert your action",
                  type: "error",
                  showCancelButton: true,
                  confirmButtonText: "Yes, Cancel Booking!",
                  cancelButtonText: "No",
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
              }).then((result) => {
                  if (result.value) {
                      _this.cancelBookingMicroservice(id);
                  } else {
                      this.$swal("Cancelled", "", "info");
                  }
              });
          } catch (err) {
              console.log(err);
          }
      },
      async cancelBookingWarning(id) {
          var _this = this;
          try {
              this.$swal({
                  title: "Are you sure?",
                  text: "You can't revert your action",
                  type: "error",
                  showCancelButton: true,
                  confirmButtonText: "Yes, Cancel Booking!",
                  cancelButtonText: "No",
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
              }).then((result) => {
                  if (result.value) {
                      _this.cancelBooking(id);
                  } else {
                      this.$swal("Cancelled", "", "info");
                  }
              });
          } catch (err) {
              console.log(err);
          }
      },
      async microserviceVoidTicketWarning(id) {
          var _this = this;
          try {
              this.$swal({
                  title: "Are you sure?",
                  text: "You can't revert your action",
                  type: "error",
                  showCancelButton: true,
                  confirmButtonText: "Yes, Void Ticket!",
                  cancelButtonText: "No",
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
              }).then((result) => {
                  if (result.value) {
                      _this.microserviceVoidTicket(id);
                  } else {
                      this.$swal("Cancelled", "", "info");
                  }
              });
          } catch (err) {
              console.log(err);
          }
      },
      async voidTicket(id) {
          try {
              axios
                  .post("/api/flight-booking/void-manual/" + id, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.$swal("Ticket Voided Successfully");
                          this.search();
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async cancelBookingMicroservice(id) {
          try {
              axios
                  .post("/api/flight-booking/booking-cancel-microservice/" + id, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.$swal("Booking Cancelled Successfully");
                          this.search();
                      } else {
                          this.$swal("Booking Not Cancelled");
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async cancelBooking(id) {
          try {
              axios
                  .post("/api/flight-booking/booking-cancel-manual/" + id, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.$swal("Booking Cancelled Successfully");
                          this.search();
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },

      async microserviceVoidTicket(id) {
          try {
              axios
                  .post("/api/flight-booking/void-microservice/" + id, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.$swal("Ticket Voided Successfully through microservice");
                          this.search();
                      } else {
                          this.$swal("Error");
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
        async refundTicketWarning(id) {
            var _this = this;
            try {
                this.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    type: "error",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Refund Ticket!",
                    cancelButtonText: "No",
                    showCloseButton: true,
                    showLoaderOnConfirm: true,
                }).then((result) => {
                    if (result.value) {
                        _this.refundTicket(id);
                    } else {
                        this.$swal("Cancelled", "", "info");
                    }
                });
            } catch (err) {
                console.log(err);
            }
        },
        async refundTicket(id) {
            try {
                axios
                    .post("/api/flight-booking/ticket-refund-manual/" + id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("Ticket Refunded Successfully");
                            this.search();
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async processEticketWarning(id) {
            var _this = this;
            try {
                this.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    type: "error",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Proccess E ticket ",
                    cancelButtonText: "No",
                    showCloseButton: true,
                    showLoaderOnConfirm: true,
                }).then((result) => {
                    if (result.value) {
                        _this.processEticket(id);
                    } else {
                        this.$swal("Cancelled", "", "info");
                    }
                });
            } catch (err) {
                console.log(err);
            }
        },
        async processEticket(id) {
            try {
                axios
                    .post("/api/flight-booking/process-e-ticket/" + id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("E Ticket Processing");
                            this.search();
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },

        async cancelBookingAndRefundWarning(id) {
            var _this = this;
            try {
                this.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    type: "error",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Cancel Booking And Refund Amount!",
                    cancelButtonText: "No",
                    showCloseButton: true,
                    showLoaderOnConfirm: true,
                }).then((result) => {
                    if (result.value) {
                        _this.bookingCancelAndRefundAmount(id);
                    } else {
                        this.$swal("Cancelled", "", "info");
                    }
                });
            } catch (err) {
                console.log(err);
            }
        },
        async bookingCancelAndRefundAmount(id) {
            try {
                axios
                    .post("/api/flight-booking/cancel-booking-refund-manual/" + id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("Ticket Refunded Successfully");
                            this.search();
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async getBookingDetail(id) {
            try {
                axios
                    .post("/api/flight-booking/details/" + id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.booking=response.data.data;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        onChange(event) {
            this.user_type=event.target.value;
            var temp=this.alladmins;
            var arr=[];
            var i;
            for (i=0;i<temp.length;i++){
                if (temp[i].account_type==event.target.value){
                    arr.push(temp[i]);
                }
            }
            this.admins = arr;
        },
      async clear() {
          this.user_type="";
          this.user_id="";
              this.booking_startdate="";
              this.booking_enddate="";
          this.booking_startdate="";
          this.booking_enddate="";
          this.booking_status="";
          this.airline_pnr="";
          this.ticket_no="";
          this.travel_startdate="";
          this.travel_enddate="";
          this.admins=this.alladmins;
      },
    errorCheck(obj) {
        if(obj.message == 'refund failed'){
            this.$swal("Payment not completed");
        }
        if(obj.message == 'booking cancel and refund failed'){
            this.$swal("Payment not completed");
        }
        if(obj.message == 'not enough balance'){
            this.visible=true;
            this.message="Not Enough Balance";
            this.errors = obj.message;
        }
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
          <b-modal
              id="modal-xl"
              size="xl"
              title="Flight Booking Details"
              title-class="font-18"
              hide-footer
          >
              <h4>Booking Info</h4>
              <div class="table-responsive table-bordered table-sm">
                  <table class="table">
                      <thead>
                      <tr>
                          <th>Key</th>
                          <th> Status</th>
                          <th>Airline Pnr</th>
                          <th>Api Pnr</th>
                          <th>Base Fare</th>
                          <th>Total Tax</th>
                          <th>Gross Fare</th>
                          <th>Ait</th>
                          <th>Markup</th>
                          <th>Commission</th>
                          <th>Invoice Fare</th>
                          <th>Currency</th>
                          <th>Airline</th>
                          <th>Trip Type</th>
                          <th>Payment Status</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                          <td>{{booking.search_reference_key}}</td>
                          <td>{{booking.booking_status_name}}</td>
                          <td>{{booking.airline_pnr}}</td>
                          <td>{{booking.api_pnr}}</td>
                          <td>{{booking.base_fare}}</td>
                          <td>{{booking.total_tax}}</td>
                          <td>{{booking.gross_fare}}</td>
                          <td>{{booking.ait}}</td>
                          <td>{{booking.markup}}</td>
                          <td>{{booking.commission}}</td>
                          <td>{{booking.invoice_fare}}</td>
                          <td>{{booking.currency}}</td>
                          <td>{{booking.airline}}</td>
                          <td>{{booking.trip_type}}</td>
                          <td>{{booking.payment_status}}</td>
                      </tr>
                      </tbody>

                      <!--                                </tbody>-->
                  </table>
              </div>

              <h4>Flight Info</h4>
              <div class="table-responsive table-bordered table-sm">
                  <table class="table mb-0">
                      <thead>
                      <tr>
                          <th>#</th>
<!--                          <th>Flight Number</th>-->
                          <th>Origin</th>
                          <th>Departure Time</th>
                          <th>Origin Terminal</th>
                          <th>Destination</th>
                          <th>Arrival Time</th>
                          <th>Destination Terminal</th>
                          <th>Baggage Info</th>
                          <th>Fare Basis</th>
                          <th>Airline</th>
                          <th>Flight Number</th>
                          <th>Travel Duration</th>
                          <th>Booking Class</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(flight,index) in booking.flight_segments"  v-bind:key="index">
                          <th>{{index+1}}</th>
                          <td>{{flight.origin_code}}</td>
                          <td>{{flight.arrival_date |  moment('LLL')}}</td>
                          <td>{{flight.origin_terminal==null ? 'N/A' : flight.origin_terminal}}</td>
                          <td>{{flight.destination_code}}</td>
                          <td>{{flight.destination_date |  moment('LLL')}}</td>
                          <td>{{flight.destination_terminal==null ? 'N/A' : flight.destination_terminal}}</td>
                          <td>{{flight.baggage_information==null ? 'N/A' : flight.baggage_information }}</td>
                          <td>{{flight.fare_basis==null ? 'N/A' : flight.fare_basis}}</td>
                          <td>{{flight.operating_airline_code==null ? 'N/A' : flight.operating_airline_code}}</td>
                          <td>{{flight.operating_flight_number==null ? 'N/A' : flight.operating_flight_number}}</td>
                          <td>{{flight.travel_duration==null ? 'N/A' : flight.travel_duration }}</td>
                          <td>{{flight.booking_class}}</td>
                      </tr>
                      </tbody>

                      <!--                                </tbody>-->
                  </table>
              </div>

              <br>

              <div>

                  <!--                            <table>-->
                  <h4>Passenger Info</h4>
                  <div class="table-responsive table-bordered table-sm">
                      <table class="table mb-0">
                          <thead>
                          <tr>
                              <th>#</th>
                              <th>Passenger Name</th>
                              <th>Birth Date</th>
                              <th>Passport No.</th>
                              <th>Passport Expiry</th>
                              <th>Passport Issue Country</th>
<!--                              <th>Passenger Type</th>-->
                              <th>Gender</th>
                              <th>Nationality</th>
                              <th>Base Fare</th>
                              <th>Total Tax</th>
                              <th>Gross Fare</th>
                              <th>Ait</th>
                              <th>Markup</th>
                              <th>Commission</th>
                              <th>Invoice Fare</th>
                              <th>Ticket No.</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(passenger,index) in booking.flight_passengers" v-bind:key="index">
                              <th>{{index+1}}</th>
                              <td>
                                  <div>
                                      {{passenger.prefix}} {{passenger.first_name}} {{passenger.last_name}}
                                  </div>
                                  <div>
                                      {{passenger.passenger_type}}
                                  </div>
                              </td>
                              <td>{{passenger.date_of_birth |  moment('ll')}}</td>
                              <td>{{passenger.passport_no==null ? 'N/A' : passenger.passport_no}}</td>
                              <td>{{passenger.passport_expiry_date==null ? 'N/A' : passenger.passport_expiry_date|  moment('ll')}}</td>
                              <td>{{passenger.passport_issue_country==null ? 'N/A' : passenger.passport_issue_country}}</td>
<!--                              <td></td>-->
                              <td>{{passenger.gender}}</td>
                              <td>{{passenger.nationality}}</td>
                              <td>{{passenger.base_fare}}</td>
                              <td>{{passenger.total_tax}}</td>
                              <td>{{passenger.gross_fare}}</td>
                              <td>{{passenger.ait}}</td>
                              <td>{{passenger.markup}}</td>
                              <td>{{passenger.commission}}</td>
                              <td>{{passenger.invoice_fare}}</td>
                              <td>{{passenger.flight_ticket==null ? 'N/A' : passenger.flight_ticket.ticket_no}}</td>
                          </tr>
                          </tbody>

                          <!--                                </tbody>-->
                      </table>
                  </div>
                  <!--                            </table>-->
              </div>
              <div class="d-print-none">
                  <div class="float-right">
                      <a @click.prevent="print(booking.id)" class="btn btn-success">
                          <i class="fa fa-print"></i>
                      </a>
<!--                      <button @click.prevent="sendMail(booking.id)" class="btn btn-primary w-md ml-1">Send Email</button>-->
                  </div>
              </div>

          </b-modal>
        <div class="card">
          <div class="card-body">
              <b-button class='float-right' v-if="display_div" v-on:click="toggleDiv()" size="sm">Collapse</b-button>
              <b-button class='float-right' v-else v-on:click="toggleDiv()" size="sm">Expand</b-button>
            <h4 class="card-title">Booking List</h4>
            <div v-if="display_div" class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="user_type">Select User Type</label>
                        <select
                            id="user_type"
                            name="user_type"
                            v-model="user_type"
                            @change="onChange($event)"
                            class="form-control"
                            placeholder="Select User Type">
                            <option value="b2b">B2B
                            </option>
                            <option value="b2c">B2C
                            </option>
                        </select>
                    </div>
                </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Select User</label>
                    <model-select :options="admins"
                                  v-model="user_id"
                                  placeholder="Select User">
                    </model-select>
<!--                  <select-->
<!--                    id="user_id"-->
<!--                    name="user_id"-->
<!--                    v-model="user_id"-->
<!--                    class="form-control"-->
<!--                    placeholder="Type Select User">-->
<!--                    <option v-for="(admin, index) in admins" :value="admin.id" v-if="admin.account_type == user_type"-->
<!--                          v-bind:key="index">{{ admin.first_name+' '+admin.last_name }}-->
<!--                  </option>-->
<!--                  </select>-->
                </div>
              </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="booking_status">Select Status</label>
                        <select
                            id="booking_status"
                            name="booking_status"
                            v-model="booking_status"
                            class="form-control"
                            placeholder="Type Status">
                            <option v-for="(status, index) in booking_statuses" :value="status.status_tag"
                                    v-bind:key="index">{{ status.status_name }}
                            </option>
                        </select>
                    </div>
                </div>
              <div class="col-md-4">
                <div>
                  <label for="start-datepicker1">Booking Start Date</label>
                  <b-form-datepicker id="start-datepicker1" v-model="booking_startdate" class="mb-2"></b-form-datepicker>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label for="end-datepicker1">Booking End Date</label>
                  <b-form-datepicker id="end-datepicker1" v-model="booking_enddate" class="mb-2"></b-form-datepicker>
                </div>
              </div>
                <div class="col-md-4">
                    <div>
                        <label for="start-datepicker2">Travel Start Date</label>
                        <b-form-datepicker id="start-datepicker2" v-model="travel_startdate" class="mb-2"></b-form-datepicker>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <label for="end-datepicker2"> Travel End Date</label>
                        <b-form-datepicker id="end-datepicker2" v-model="travel_enddate" class="mb-2"></b-form-datepicker>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="airline_pnr">Airline Pnr</label>
                        <input
                            id="airline_pnr"
                            v-model="airline_pnr"
                            name="airline_pnr"
                            type="text"
                            class="form-control"
                            placeholder="Type Airline Pnr"
                        />
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="ticket_no">Ticket No</label>
                        <input
                            id="ticket_no"
                            v-model="ticket_no"
                            name="ticket_no"
                            type="text"
                            class="form-control"
                            placeholder="Type Ticket No."
                        />
                    </div>
                </div>
              <div class="col-md-12 text-center"><span><button class="btn btn-primary" @click.prevent="search()">Search</button></span><span><button class="btn btn-light" @click.prevent="clear()">Clear</button></span></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Booking List</h4>
            <div class="table-responsive">
              <table class="table mb-0 table-striped fixed">
                <thead>
                  <tr>
                    <th class="index-width">SL</th>
                      <th class="booking-date-width">Booking /Travel Date</th>
                      <th class="passengers-width">Passengers</th>
                      <th>Book By</th>
                      <th class="search-ref-key-index">Key</th>
                    <th>
                        <div>API/Airline Pnr/</div>
                        <div>Routes/Trip Type</div>
                    </th>
                      <th>
                          <div class="row">
                              Gross Fare/
                          </div>
                          <div class="row">
                              Ait/
                          </div>
                          <div class="row">
                              Markup
                          </div>

                      </th>
                      <th>
                          <div class="row">
                              Commission/
                          </div>
                          <div class="row">
                              Invoice fare/
                          </div>
                          <div class="row">
                              Currency
                          </div>
                      </th>
                      <th class="booking-status-width">Booking/ Payment Status</th>
                      <th class="action-index">Action</th>
                  </tr>
                  <tr>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td><input type="text" class="app-search form-control" v-model="search_uname" placeholder="Username" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search1" placeholder="key" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_pnr" placeholder="Pnr" /></td>

                  </tr>
                </thead>
                <tbody >
                  <tr v-for="(booking,index) in filteredList"  v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                      <td>
                          <div class="row">
                              <div class="col-xs-4">{{booking.created_at|  moment("D MMM YYYY, H:mm")}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{booking.travel_date==null?'N/A':booking.travel_date|  moment("D MMM YYYY, H:mm")}}</div>
                          </div>
                      </td>
                      <td>
                          <div  v-for="(passeneger,index) in booking.passenger_info['name']">
                              <div class="col-xs-4">{{passeneger}}</div>
                          </div>
                          <div  v-for="(passport,index) in booking.passenger_info['passport']">
                              <div v-if="passport !='N/A'" class="col-xs-4">{{passport}}</div>
                          </div>
                      </td>
                      <td v-if="booking.username!=null">
                          <div v-if="booking.account_type==='b2b'" class="row">
                              <div v-if="booking.username!=null" class="col-xs-4">{{booking.agency_name}}</div>
                          </div>
                          <div v-if="booking.account_type==='b2c'" class="row">
                              <div v-if="booking.username!=null" class="col-xs-4">{{booking.user_name+"("+booking.account_type+")"}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"><router-link  :to="{ name: 'admin_agent_details', params: {id: booking.user_id } }" target="_blank" >{{booking.username==null ? 'N/A' : booking.username}}</router-link></div>
                          </div>
                      </td>
                      <td v-else>N/A</td>
                      <td><a href="" v-b-modal.modal-xl  @click.prevent="getBookingDetail(booking.id)">{{booking.search_reference_key}}</a></td>

                      <td>
                          <div class="row">
                              <div class="col-xs-4">{{booking.api_vendor_name+"-"+booking.api_pnr}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{booking.airline+"-"+booking.airline_pnr}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{booking.flight_segments}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{booking.trip_type}}</div>
                          </div>
                      </td>
                      <td>
                          <div class="row">
                              <div class="col-xs-4">{{booking.gross_fare}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{booking.ait==null ? 'N/A' :booking.ait}} </div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{booking.markup=null ? 'N/A' : booking.markup}}</div>
                          </div>
                      </td>
                      <td>
                          <div class="row">
                              <div class="col-xs-4">{{booking.commission==null ? 'N/A' :booking.commission}} </div>
                          </div>
                          <div class="row">
                              <b-badge variant="info" class="ml-1">{{booking.invoice_fare==null ? 'N/A' :booking.invoice_fare}}</b-badge>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{booking.currency==null ? 'N/A' :booking.currency}} </div>
                          </div>
                      </td>
                      <td>
                          <div class="row">
                              <div class="col-xs-6">
                                  <b-badge v-if="booking.booking_status_id===7" variant="success" class="ml-1">{{booking.booking_status.status_name}}</b-badge>
                                  <b-badge v-else-if="booking.booking_status_id===5" variant="primary" class="ml-1">{{booking.booking_status.status_name}}</b-badge>
                                  <b-badge v-else-if="booking.booking_status_id===2" variant="warning" class="ml-1">{{booking.booking_status.status_name}}</b-badge>
                                  <b-badge v-else-if="booking.booking_status_id===3" variant="danger" class="ml-1">{{booking.booking_status.status_name}}</b-badge>
                                  <b-badge v-else variant="dark" class="ml-1">{{booking.booking_status.status_name}}</b-badge>
                              </div>
                          </div>
                          <div class="row">
                              <b-badge v-if="booking.payment_status=='full-paid'" variant="success" class="ml-1">{{booking.payment_status}}</b-badge>
                              <b-badge v-else-if="booking.payment_status=='partially-paid'" variant="primary" class="ml-1">{{booking.payment_status}}</b-badge>
                              <b-badge v-else-if="booking.payment_status=='unpaid'" variant="danger" class="ml-1">{{booking.payment_status}}</b-badge>
                              <b-badge v-else variant="dark" class="ml-1">{{booking.payment_status}}</b-badge>
                          </div>
                      </td>
                      <td>
                          <b-dropdown  class="card-drop" variant="white" right toggle-class="p-0">
                              <template v-slot:button-content>
                                  <i class="mdi mdi-dots-horizontal font-size-18"></i>
                              </template>
                              <b-dropdown-item-btn><router-link :to="{ name: 'booking_ticket_invoice', params: {id: booking.id } }" target="_blank" class="btn btn-primary btn-sm"><i class="fas fa-edit"></i> Invoice</router-link></b-dropdown-item-btn>
<!--                              <b-dropdown-item-btn><router-link :to="{ name: 'booking_details', params: {id: booking.id } }" target="_blank" class="btn btn-primary btn-sm"><i class="fas fa-edit"></i> Details</router-link></b-dropdown-item-btn>-->
                              <b-dropdown-item>  <b-button v-b-modal.modal-xl variant="primary" class="btn btn-primary btn-sm" @click.prevent="getBookingDetail(booking.id)"><i class="fas fa-edit"></i>Details</b-button></b-dropdown-item>
<!--                              <b-dropdown-item-btn v-if="booking.booking_status.status_tag=='ticket-confirmed'"><router-link :to="{ name: 'booking_ticket', params: {id: booking.id } }" target="_blank" class="btn btn-primary btn-sm" :disabled="true"><i class="fas fa-edit"></i> Ticket</router-link></b-dropdown-item-btn>-->
                              <b-dropdown-item-btn><router-link :to="{ name: 'flight_booking_update', params: {id: booking.id ,is_ticketing:false} }" class="btn btn-primary btn-sm" ><i class="fas fa-edit"></i> Edit</router-link></b-dropdown-item-btn>
                              <b-dropdown-item v-if="booking.booking_status.status_tag=='ticket-confirmed' && booking.void"><button class="btn btn-primary btn-sm" @click.prevent="voidTicketWarning(booking.id)">mVoid</button></b-dropdown-item>
                              <b-dropdown-item v-if="booking.booking_status.status_tag=='booking-confirmed'"><button class="btn btn-primary btn-sm" @click.prevent="processEticketWarning(booking.id)">eTicket Process</button></b-dropdown-item>
                              <b-dropdown-item v-if="booking.booking_status.status_tag=='ticket-confirmed' && booking.void"><button class="btn btn-primary btn-sm" @click.prevent="microserviceVoidTicketWarning(booking.id)">dVoid</button></b-dropdown-item>
                              <b-dropdown-item v-if="booking.booking_status.status_tag=='booking-confirmed' || booking.booking_status.status_tag=='voided' || booking.booking_status.status_tag=='e-ticket-processing'"><button class="btn btn-primary btn-sm" @click.prevent="cancelBookingWarning(booking.id)">mCancel</button></b-dropdown-item>
                              <b-dropdown-item v-if="booking.booking_status.status_tag=='booking-confirmed' || booking.booking_status.status_tag=='voided' || booking.booking_status.status_tag=='e-ticket-processing'"><button class="btn btn-primary btn-sm" @click.prevent="cancelBookingMicroserviceWarning(booking.id)">dCancel</button></b-dropdown-item>
                              <b-dropdown-item v-if="booking.booking_status.status_tag=='ticket-confirmed' && !booking.void"><button class="btn btn-primary btn-sm" @click.prevent="refundTicketWarning(booking.id)">mRefund</button></b-dropdown-item>
                              <b-dropdown-item v-if="booking.booking_status.status_tag=='ticket-confirmed' && !booking.void || booking.booking_status.status_tag=='e-ticket-processing'"><router-link :to="{ name: 'ticket_update', params: {searchReferenceKey: booking.search_reference_key ,isFromBookingList:true} }" class="btn btn-primary btn-sm"><i class="fas fa-edit"></i>{{booking.booking_status.status_tag=='e-ticket-processing' ? 'Issue Ticket' : 'Reissue'}}</router-link></b-dropdown-item>
                              <b-dropdown-item v-if="booking.booking_status.status_tag=='e-ticket-processing'"><button class="btn btn-primary btn-sm" @click.prevent="cancelBookingAndRefundWarning(booking.id)">Cancel And Refund</button></b-dropdown-item>
                          </b-dropdown>
                      </td>
<!--                      <td><router-link :to="{ name: 'booking_ticket_invoice', params: {id: booking.id } }" target="_blank" class="btn btn-primary btn-sm"><i class="fas fa-edit"></i> Invoice</router-link> </td>-->
<!--                      <td><router-link :to="{ name: 'booking_details', params: {id: booking.id } }" target="_blank" class="btn btn-primary btn-sm"><i class="fas fa-edit"></i> Details</router-link> </td>-->
<!--                      <td v-if="booking.booking_status.status_tag=='ticket-confirmed'"><router-link :to="{ name: 'booking_ticket', params: {id: booking.id } }" target="_blank" class="btn btn-primary btn-sm" :disabled="true"><i class="fas fa-edit"></i> Ticket</router-link> </td>-->
<!--                      <td v-else>No Ticket Issued</td>-->
<!--                      <td v-if="booking.booking_status.status_tag=='booking-confirmed'"><button class="btn btn-primary btn-sm" @click.prevent="voidTicketWarning(booking.id)">Void Ticket</button></td>-->
<!--                      <td v-else>Booking Not Confirmed</td>-->
<!--                      <td v-if="booking.booking_status.status_tag=='booking-confirmed'"><button class="btn btn-primary btn-sm" @click.prevent="microserviceVoidTicketWarning(booking.id)">Void Ticket Microservice</button></td>-->
<!--                      <td v-else>Booking Not Confirmed</td>-->
<!--                      <td v-if="booking.booking_status.status_tag=='booking-confirmed'"><button class="btn btn-primary btn-sm" @click.prevent="cancelBookingWarning(booking.id)">Cancel Booking</button></td>-->
<!--                      <td v-else>Booking Not Confirmed</td>-->
<!--                      <td v-if="booking.booking_status.status_tag=='booking-confirmed'"><button class="btn btn-primary btn-sm" @click.prevent="cancelBookingMicroserviceWarning(booking.id)">Cancel Booking microservice</button></td>-->
<!--                      <td v-else>Booking Not Confirmed</td>-->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.dropdown-menu.show {
    display: block;
    z-index: 10003;
}
#start-datepicker1__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
#end-datepicker1__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
#start-datepicker2__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
#end-datepicker2__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
.float-right{
    float: right;
}
</style>
<style scoped>
table>tr>td{
    width:30%;
    height:30px;
}
.margin-5px{
    margin-right: 5px;
}
.width-20px{
    width: 20px;
}
.padding-5px{
    padding-right: 3%;
    padding-left: 3%;
}
table>tr>td:nth-child(odd) {
    font-weight: 600;
}
.table-responsive img{
    width:60px;
}
/*table.fixed { table-layout:fixed; }*/
/*.index-width{*/
/*    width:45px;*/
/*}*/
/*.booking-date-width{*/
/*    width:100px;*/
/*}*/
/*.search-ref-key-index{*/
/*    width:150px;*/
/*}*/
/*.action-index{*/
/*    width: 50px;*/
/*}*/
/*.booking-status-width{*/
/*    width:110px;*/
/*}*/
/*.passengers-width{*/
/*    width:150px;*/
/*}*/
</style>
